<template>
  <footer class="footer">
    <nav class="links">
      <a
        v-for="item in footerInfo1"
        :key="item.text"
        class="footer-link"
        :href="item.href"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ item.text }}
      </a>
      <a
        v-for="item in footerInfo2"
        :key="item.text"
        class="footer-link"
        :href="item.href"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ item.text }}
      </a>
    </nav>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      footerInfo1: [
        {
          text: "Privacy Policy",
          href: "https://www.piplanning.io/legal/privacy-policy",
        },
        {
          text: "Terms of Service",
          href: "https://scaledagile.com/pioterms",
        },
      ],
      footerInfo2: [
        {
          text: "Documentation",
          href: "https://howto.piplanning.io",
        },
        {
          text: "Releases",
          href: "https://piplanning.io/releases",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/colors" as c;
@use "@/styles/mixins/typography";

.footer {
  width: 100%;
  box-sizing: border-box;
  height: 48px;
  border-top: 1px solid c.$border-subtle;
  background: c.$white;
  display: flex;
  align-items: center;
  padding: 0 24px;
}

.links {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-link {
  @include typography.small;

  color: c.$text-subtle;
  text-decoration: none;

  &:hover {
    color: c.$text;
    text-decoration: underline;
  }
}
</style>
